import React from 'react';
import useFetch from 'react-fetch-hook';
import { toast } from 'react-toastify';

import { links } from '../static/links';

import { Layout, Seo, Spinner } from '../components';
import { PageTitle, PageAbout, TwoColumnsGrid, CallUs } from '../sections';

const Services = () => {
  const { isLoading, data, error } = useFetch(links.services_page);
  const [pageData, setPageData] = React.useState();
  const [pageSeoData, setPageSeoData] = React.useState();

  const services = useFetch(links.all_services);

  React.useEffect(() => {
    if (data) {
      setPageData(data[0].acf);
      setPageSeoData(data[0].yoast_head_json);
    }
  }, [data]);

  React.useEffect(() => {
    if (error) toast.error('Data loading error. Please reload the page!');
  }, [error]);

  if (isLoading) return <Spinner />;

  return (
    <Layout page="services-page">
      <Seo data={pageSeoData} />
      <PageTitle title={pageData?.page_title} />
      <PageAbout title={pageData?.section_title} content={[pageData?.left_column, pageData?.right_column]} />
      {!services?.isLoading && <TwoColumnsGrid grid={services?.data.sort((a, b) => a.id - b.id)} parent="services" />}
      <CallUs title="Get a Free Estimate Today!" button="Get Started" isFullWidth />
    </Layout>
  );
};

export default Services;
